'use strict'

export let norwegian={
  general: {
    title: "Organisasjon",
    approach: "Tilnærming",
    stakeholdersInDefinition: "Interessenter beskrevet i projektdefinisjonen",
    stakeholder: "Interessent",
    readMore: "les mer",
    hideDetails: "skjul detaljer",
    leavePage: "Forlat denne siden",
    addRole: "Legg til rolle",
    assignRole: "Tildel rolle",
    addRoleDetails: "legg til detaljer om rollen",
    cancel: "Avbryt",
    update: "Oppdater",
    addStakeholder: "Legg til interessent",
    newStakeholder: "Ny interessent",
    messageEmailFirst: "vennligst angi epost først",
    helpName: "Interessentens fulle navn"
  },

  roles: {
    title: "Rollebeskrivelser",
    headings: {
      name: "Navn",
      email:"Epost",
      role: "Rolle",
      details: "Detaljer"
    },
    project: {
      selectRole: "-- velg prosjektrolle --",
      actions: {
        appointExecutive: "Utnevn prosjekteier",
        appointProjectManager: "Utnevn prosjektleder",
      },
      descriptions: {
        board: {
          title: "Prosjektstyret",
          ingress: `Prosjektstyret er ansvarlig for den overordnede retningen og styringen av prosjektet.
            Prosjektstyret ledes av forretningen (prosjekteier) og balanseres med representanter for brukerne og leverandørene.`,
          details: `En prosjektorganisasjon er satt opp med utgangspunkt i prinsippet om at det alltid er tre primære interessentkategorier: forretningen, brukere og leverandører.
            Følgende roller representerer disse interessentkategorienen i prosjektstyret for å sikre balansert styring til prosjektlederen`,
          responsibility: `Prosjektstyret er ansvarlig for den overordnede retningen og ledelse av prosjektet.
            Legg merke til at prosjektstyret ikke er et demokrati kontrollert ved avstemning. Prosjektstyret er ledet av prosjekteier som sitter med det overordnede ansvaret.`,
        },
        assuranceRoles: {
          title: "Prosjektsikring",
          ingress: `Medlemmene i prosjektstyret kan trenge hjelp, varamedlemmer, til å lede arbeidet på daglig basis. Dette er sikringsrollene.`,
          details: `Stedfortreder for Seniorleverandør er Leverandørsikring. Stedfortreder for Seniorbruker er Brukersikring. Stedfortreder for Prosjekteier er Forretningssikring`
        },
        teamStructure: {
          title: "Organisering av prosjektet",
          details: `Hensikten med organisasjonstemaet er å definere og etablere prosjektets strutktur, ansvar og myndighet (hvem?). Prosjektet skal ha et prosjektstyre ledet av prosjekteieren. Prosjektstyret bør ha en eller flere seniorbrukere og seniorleverandører som støtter prosjekteieren. Det skal være en teamleder for hver disiplin som bidrar i prosjektet.`,
          additionalInformation: `En person kan ta flere roller hvis personen har kapasitet og kompetanse, og hvis det ikke medfører interessekonflikt.`
        }
      },
      roles: {
        executive: {
          title: "Prosjekteier",
          summary: "representer forretningens behov. Det er ansett som obligatorisk å ha en, og bare en, prosjekteier",
          ingress: `Er den endelige ansvarlige for prosjektet med fokus på å oppnå målene og levere et produkt som oppnår gevinstene.`,
          details: `Prosjekteier, enkelte ganger omtalt som sponsor, er til syvende og sist ansvarlig for prosjektet
            og for beslutninger knyttet til ledelse av arbeidet, støttet av seniorbruker og seniorleverandør.
            Prosjekteiers rolle er å sikre at prosjektet er fokusert gjennom livsløpet på å oppnå målene og å levere et produkt
            som sikrer gevinstene med balanserte krav fra ulike interessenter. I hele prosjektets varighet er prosjekteieren ansvarlig for prosjektbegrunnelsen (business case).`,
          additionalInformation: `Utnevning av prosjekteier bør være den aller første aktiviteten.`
        },
        seniorUser: {
          title: "Seniorbruker",
          summary: "representerer brukerne av prosjektets leveranser. Det kan være en eller mange seniorbrukere i prosjektstyret",
          ingress: `Er representant for brukerne av prosjektets leveranser og sikrer at foventede gevinster er realisert.`,
          details: `Seniorbrukeren er ansvarlig for å spesifisere behovene til de som skal bruke prosjektets produkter,
            forplikter ressurser fra brukerne og overvåker produktet mot angitte krav. Seniorbrukeren spesifiserer og forsikrer gevinstene og kvalitetene i prosjektets leveranser, og holdes ansvarlig for at forespeilede gevinster faktisk blir realisert.`
        },
        seniorSupplier: {
          title: "Seniorleverandør",
          summary: "representere de som vil lage prosjektets leveranser. Det kan være en eller mange seniorleverandører i prosjektstyret",
          ingress: `Er representant for leverandørene som skal levere prosjektets produkter og ansvarlig for kvaliteten på disse.`,
          details: `Seniorleverandøren representerter interessene til de som designer, utvikler, tilretteleger,
            anskaffer og implementerer prosjektets produkter, sikrer de nødvendige ressursene og er anvarlig for
            kvaliteten på produktene som leveres av leverandøren(e) så vel som for den tekniske integriteten.`
        },
        projectManager: {
          title: "Projektleder",
          ingress: `Følger opp prosjektet på daglig basis innenfor begrensningene gitt av prosjektstyret.`,
          details: `Prosjektleder har myndighet til å lede prosjektet på daglig basis innenfor de gitte
            begrensningene satt av prosjektstyret. Prosjektlederens hovedansvar er å sikre at prosjektet
            produserer de nødvendige produktene innenfor de angitte toleransene for tid, kostnad, kvalitet, omfang,
            risiko og gevinster, samt at det endelige produktet er i stand til å oppnå gevinstene
            definert i begrunnelsen for prosjektet.`,
          additionalInformation: `Prosjektlederen bør utnevnes når prosjektet starter opp.`
        },
        teamManager: {
          title: "Teamleder",
          ingress: `Sikrer at avtalte produkter blir produsert i prosjektet i henhold definisjonen gitt av prosjektlederen.`,
          details: `Teamlederen sikrer produksjon av produktene prosjektlederen har definert til en passende kvalitet,
            innenfor en tidsramme og til en akseptabel pris for prosjektstyret. Teamlederen rapporterer til og
            ledes av prosjektlederen. Teamlederen kommer til enighet om arbeidet med prosjektlederen, planlegger
            teamets arbeid, fører tilsyn med utførelsen og rapporterer kvalitet og fremdrift til prosjektlederen.
            Teamlederen får godkjenning på fullførte produkter.`
        }
      },
      executive: "Prosjekteier",
      seniorUser: "Seniorbruker",
      seniorSupplier: "Seniorleverandør",
      businessAssurance: "Forretningssikring",
      projectManager: "Prosjektleder",
      teamManager: "Teamleder",
      projectSupport: "Prosjektstøtte",
      changeAuthority: "Change Authority",
      stakeholder: "Interessent",
      userAssurance: "Brukersikring",
      supplierAssurance: "Leverandørsikring",
      teamMember: "Teammedlem"
    },
    programme: {
      selectRole: "-- velg rolle i programmet --",
      actions: {
        appointSRO: "Utnevn programeier (SRO)",
        appointProgrammeManager: "Utnevn programleder"
      },
      descriptions: {
        teamStructure: {
          title: "Organisering av programmet",
          details: `Hensikten med organisasjonstemaet er å definere og etablere programmets struktur, ansvar og myndighet (hvem?). Programmet skal ha et programstyre ledet av programeieren (SRO).`,
          additionalInformation: `Programstyret bør ha en eller flere endringsledere (BCM) som er ansvarlige for å realisere gevinstene.`
        }
      },
      roles: {
        seniorResponsibleOwner: {
          title: "Programeier (SRO)",
          details: "Programeieren (SRO) er ansvarlig for programmet og å sikre at målene oppnås.",
          additionalInformation: "Personen som innehar denne rollen må ha ansiennitet og myndighet til å lede programstyret, samt fullmakt til å lede programme."
        },
        programmeManager: {
          title: "Programleder",
          details: `Programlederen har den daglige ledelsen av programmet med å planlegge og utforme programmet, utvikle styringsrammene, og administrere programmets budsjett, risiko og saker.`,
          additionalInformation: "Programlederen rapporterer fremdriften av programmet jevnlig til SRO og håndterer kommunikasjon med interessenter."
        }
      },
      seniorResponsibleOwner: "Programeier (SRO)",
      programmeManager: "Programleder",
      businessChangeManager: "Endringsleder (BCM)",
      stakeholder :"Interessent",
      teamMember: "Teammedlem"
    },
    product: {
      selectRole: "-- velg rolle i produktet --",
      actions: {
        appointExecutive: "Utpek produktansvarlig",
        appointProductManager: "Utpek produktleder"
      },
      descriptions: {
        teamStructure: {
          title: "Organisering av produktet",
          details: `Effektive produktteam må dekke levedyktighet, ønskelighet og gjennomførbarhet. Produktlederen bør sørge for levedyktigheten, hvorfor noe skal gjøres. Det bør også settes noen til å ta ansvar for ønskelighet, hvordan produktet må være for brukeren. Enkelte ganger er dette en designer.`,
          additionalInformation: `Gjennomførbarhet er å sørge for at vi vet hvordan produktet skal lages. En teknisk seniorperson bør ta dette ansvaret. Bruk Teamleder-rollen for å dokumentere rollene som ikke er eksplisitt oppført.`
        }
      },
      roles: {
        executive: {
          title: "Produktansvarlig",
          details: "Ansvarlig for produktet ivaretar suksessen til produktet og har fokus på å oppnå målene og levere gevinstene. Det anses som obligatorisk å ha en, og bare en, produktansvarlig.",
          additionalInformation: "Utnevnelse av ansvarlig for produkt bør være det første som gjøres. Ansvarlig for produktet kalles noen ganger for sponsor eller eier."
        },
        productManager: {
          title: "Produktleder",
          details: "Ledelse av produktet spenner fra forskning på markedet, kunder og konkurrenter, til å utvikle og opprettholde produktvisjonen og langtidsplanen.",
          additionalInformation: "I denne sammenheng jobber produktlederen med produktteamet for å definere, prioritere og teste leveranser av produktfunksjoner som skal skape mest mulig verdi og produserer høyest mulig forretningsresultat."
        }
      },
      executive: "Produktansvalig",
      productManager: "Produktleder",
      teamManager: "Teamleder",
      stakeholder: "Interessent",
      teamMember: "Teammedlem"
    }
  },

  teamStructure: {
    title: "Organisering"
  },
  communicationManagementApproach: {
    title: "Tilnærming til kommunikasjon",
    description: "Tilnærming til kommunkasjon beskriver hvordan informasjon formidles til og mottas fra interessenter i prosjektet.",
    fields: {
      process: {
        title: "Kommunikasjonsprosedyre",
        help: `Vil prosjektet ha noen regler, rutiner eller prosesser som sikrer at relevant informasjon deles i prosjektgruppen, med interessentene, med organisasjon eller med tredje part?
          Er det noen standard prosedyrer eller retningslinjer som skal følges for kommunikasjon? Er det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor?
          Hvordan skal vi sørge for at prosedyren følges?
          Er det standarder eller maler som skal brukes?
          Hvordan fungerer kommunikasjonsprosedyren med tredje part?
          Hvordan håndterer prosjektet klassifisert informasjon og personvern?`,
        description: "Beskriv kommunikasjonsmetoder og prosedyrer som skal brukes innenfor prosjektet og eksternt til prosjektet"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: `Hvilke teknikker og kommunikasjonsverktøy vil bli brukt til å dele informasjon?
          Vil det være noen logging av intern eller ekstern kommunikasjon?
          Vil prosjektet bruke sosiale medier, e-post, blogger, intranett, møter, workshops, brev, dokumenter?`,
        description: "Beskriv hvilke verktøy eller teknikker prosjektet skal bruke for å sikre at all nødvendig informasjon deles."
      },
      reporting: {
        title: "Rapportering",
        help: `Når gjøres formell kommunikasjon?
          Hvilke spesifikke kommunikasjonsaktiviteter gjøres ved prosjektoppstarter, start / slutt på etappe eller ved prosjektavsluttning?`,
        description: "Beskriv kommunikasjonsrapporter som skal bli produsert, deres formål, tidspunkt og mottakere."
      },
      timing: {
        title: "Tidspunkt for kommunikasjon",
        help: `Når gjøres formell kommunikasjon? Når holdes møter?
          Skal det gjøres spesielle kommunikasjonsaktiviteter i begynnelsen av prosjektet, begynnelse / slutten av etapper eller ved prosjektavslutning?`,
        description: "Beskriv tidspunktet for formelle kommunikasjonsaktiviteter"
      },
      roles: {
        title: "Roller og ansvar",
        help: `Hvem er ansvarlig for kommunikasjonsprosedyren / retningslinjer for kommunkasjon?
          Hvem bestemmer hva som kan kommuniseres or når?
          Hvem er ansvarlig for å kommunisere hva til hvem?`,
        description: "Definer roller og ansvar for kommunikasjon"
      }
    }
  },
  stakeholderAnalysis: {
    title: "Interessentanalyse",
    fields: {
      stakeholders: {
        title: "Kommunikasjon til interessenter",
        columns: {
          name: { title: "Interessent" },
          message: { title: "Informasjonsbehov" },
          requiredInformation: { title: "Trenger" },
          providedInformation: { title: "Leverer" },
          frequency: {title: "Frekvens" }
        },
        options: {
          addEntry: {
            title : "Legg til interessent"
          }
        },
        samples: [
          {
            name: "Eksempelinteressent",
            message:"Informasjon om fremdrift",
            requiredInformation: "Statusrapport",
            providedInformation: "Brukerbehov",
            frequency: "Månedlig"
          }
        ]
      }
    }
  },
  stakeholder: {
    title: "Interessent",
    fields: {
      name: {
        title: "Navn på interessent",
        help: `Hvem har finansiell interesse?
          Hvem styrer ressurser?
          Hvem vil bli påvirket?
          Noen som eier eller etterprøver retningslinjer og prosedyrer?
          Hvem er de største tilhengerne?
          Hvem er de viktigste motstanderne?
          Eventuelle eksterne partnere, konkurrenter eller brukere?`,
        description: "Navn, rolle eller gruppe"
      },
      message: {
        title: "Informasjonsbehov",
        help: `Hva er hovedbudskapet til denne interessenten?`,
        description: "Angi hovedbudskapet til interessenten"
      }
    }
  },
  information: {
    title: "Informasjon",
    fields: {
      requiredInformation: {
        title: "Informasjon påkrevd fra prosjektet",
        help: `Hvilken informasjon vil denne interessenten be om?
          Hvilken informasjon vil vi denne interessenten skal motta?
          Er det noe informasjon interessenten ikke vil motta?
          Har prosjektet spesifikk informasjon som ikke skal deles med denne interessenten?`,
        description: "Angi informasjon kommunisert fra prosjektet til interessenten"
      },
      providedInformation: {
        title: "Information nødvendig til prosjektet",
        help: `Er prosjektet avhengig av informasjon fra denne interessent? Hvis ja, hvilken type informasjon er det?`,
        description: "Angi informasjon som prosjektet trenger fra denne interessenten"
      }
    }
  },
  communication: {
    title: "Kommunikasjon",
    fields: {
      frequency: {
        title: "Frekvens på kommunikasjon",
        help:`Hvor ofte skal prosjektet kommunisere med denne interessenten?
          Vil frekvensen variere avhengig av typen informasjon?`,
        description: "Beskriv kommunikasjonsfrekvensen til interessenten"
      },
      means: {
        title: "Kommunikasjonsmåter",
        help: `Hvilken metode vil bli brukt til å kommunisere med denne interessenten?
          Hva blir kommunikasjonsverktøyet? Møter, digitale verktøy?`,
        description: "Kommunikasjonsmiddel"
      },
      format: {
        title: "Format på kommunikasjonen",
        help: `Hvilket format vil bli brukt til å dele informasjonen?
          Dokument, presentasjon, video, bilder, muntlig, lang, kort, kontekst-rikt/fattig?`,
        description: "Format"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/organization/labels/norwegian.js